import { EXPEDIA_TYPE_CANCELLATION_RULE_NON_REFUNDABLE, EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE, INVIA_TYPE_GROUP_FLEX, INVIA_TYPE_GROUP_PROMOTION, INVIA_TYPE_GROUP_SAFETY } from '../../../../components/HotelServices/components/Specials/consts.js';
export const hasCancellationRule = specialInfo => {
  return specialInfo.some(special => special?.inviaType && special.inviaType.startsWith(EXPEDIA_TYPE_CANCELLATION_RULE_NON_REFUNDABLE) && special.inviaType !== EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE);
};
export const getAllowedSpecials = (specialInfo,
/**
 * list of promotion types in the order they should be displayed
 * not matching types will be sorted at the end
 *
 * @example ['special' | 'flex' | 'safety']
 */
order = ['special', 'flex', 'safety', 'none']) => {
  const withPromotionTypes = specialInfo.reduce((accumulator, special) => {
    const promotionType = special.inviaType?.startsWith(INVIA_TYPE_GROUP_PROMOTION) ? 'special' : special.inviaType?.startsWith(INVIA_TYPE_GROUP_FLEX) || special?.inviaType === EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE ? 'flex' : special.inviaType?.startsWith(INVIA_TYPE_GROUP_SAFETY) ? 'safety' : special.inviaType?.startsWith(EXPEDIA_TYPE_CANCELLATION_RULE_NON_REFUNDABLE) && special?.inviaType !== EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE ? 'none' : '';
    if (promotionType) {
      accumulator.push({
        ...special,
        promotionType
      });
    }
    return accumulator;
  }, []);
  return withPromotionTypes.sort((a, b) => {
    return order.indexOf(a.promotionType) - order.indexOf(b.promotionType);
  });
};